import React from "react";
import { Link } from "react-router-dom";
import templeJson from "../../config/temple.json";
import { Container, Grid } from "@mui/material";
function Community() {
  return (
    <>
      <Container maxWidth={'xl'} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">Community</h1>
        <ol className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active">Community</li>
        </ol>
      </Container>
      <Container className="py-5">
        <Grid className="text-center mb-4">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            {templeJson["templeName"]}          
          </h6>
          <h1 className="mb-3">
            <span className="text-secundary">Community</span>
          </h1>
        </Grid>
        <Grid className="text-center">
          <h2>Comming Soon</h2>
        </Grid>
      </Container>
    </>
  );
}

export default Community;
